import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'

// Mock until BE-1 (https://app.clickup.com/t/86c7fufcj) lands.
// Each entry is the user-facing label; backend will accept the same string as filter value.
// 3D Only list mirrors Figma node 590:28507 from Listing Page 2.0
// (https://www.figma.com/design/82bsGlkDIJNqvlZjdEWH2v/Listing-Page-2.0?node-id=590-28507).
// 3D Print Only list is a temporary placeholder until product/design provides the official set.
export const STYLES_BY_ASSET_TYPE = {
  [ASSET_TYPE.THREE_D_ONLY]: [
    'Abstract',
    'Ancient',
    'Anime',
    'Cartoon',
    'Classic',
    'Cyberpunk',
    'Gothic',
    'Grunge',
    'Historical',
    'Retro',
    'Vintage',
    'Industrial',
    'Military',
    'Minimalist',
    'Modern',
    'Organic',
    'Pixel',
    'Playful',
    'Postapocalyptic',
    'Realistic',
    'Sci-Fi',
    'Fantasy',
    'Steampunk',
    'Stylized',
    'Victorian',
    'Voxel',
    'Photorealistic',
  ],
  [ASSET_TYPE.THREE_D_PRINT_ONLY]: [
    'Articulated',
    'Tabletop',
    'Cosplay',
    'Functional',
    'Decorative',
    'Miniature',
    'Mechanical',
    'Organic',
    'Geometric',
  ],
}

export const getStylesForAssetType = (assetType) => STYLES_BY_ASSET_TYPE[assetType] || []
